import { createReducer } from 'redux-act'
import u from 'updeep'
import queryString from 'query-string'

const query = queryString.parse(window.location.search)
const lang = query.lang || ''

import {
  updateCellarLanguages,
  updateCellarLanguage,
  updateEventLanguages,
  updateEventLanguage,
  updateSelectLanguages,
} from 'actions/languages'

const initialState = {
  cellarLanguages: [{ value: lang }],
  cellarLanguage: lang,
  eventLanguages: [{ value: lang }],
  eventLanguage: lang,
  selectLanguages: [{ value: lang }],
}

export default createReducer({
  [updateCellarLanguages]: (state, cellarLanguages) => {
    return u({ cellarLanguages }, state)
  },
  [updateCellarLanguage]: (state, cellarLanguage) => {
    return u({ cellarLanguage }, state)
  },
  [updateEventLanguages]: (state, eventLanguages) => {
    return u({ eventLanguages }, state)
  },
  [updateEventLanguage]: (state, eventLanguage) => {
    return u({ eventLanguage }, state)
  },
  [updateSelectLanguages]: (state, selectLanguages) => {
    return u({ selectLanguages }, state)
  },
}, initialState)
